import { TextField } from '@material-ui/core';
import CustomText from 'components/common/text/CustomText';
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import MuiWrapper from 'components/common/input/MuiWrapper';
import useInput from 'lib/hooks/useInput';
import { PatientActions, AppActions } from 'store/actionCreators';
import { encodedByAES56, useDidUpdateEffect } from 'lib/utils';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
import { IPatientInfo } from 'lib/types/patientTypes';
import { useTranslation } from 'react-i18next';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import { color } from 'styles/utils';
import MuiButton from 'components/common/button/MuiButton';
import { T } from 'components/common/text';
import { useShallowAppSelector } from 'store/hooks';
import { useHistory } from 'react-router-dom';
import { invalidFormType } from 'lib/mapper';
import { BASE_AUTH_URL } from 'lib/setting';
import cx from 'classnames';

interface DeletePatientModalProps {
  patientInfo: IPatientInfo;
}

function DeletePatientModalContainer({ patientInfo }: DeletePatientModalProps) {
  const { user, deletePatientSuccess, deletePatientFailure, deletePatientError } =
    useShallowAppSelector(state => ({
      user: state.user.user,
      deletePatientSuccess: state.patient.deletePatient.success,
      deletePatientFailure: state.patient.deletePatient.failure,
      deletePatientError: state.patient.deletePatient.error,
    }));

  const { ipcRenderer } = window;
  const { t } = useTranslation();
  const history = useHistory();
  const password = useInput('');
  const [isShowPassword, setIsShowPassword] = useState(false);
  const isProviderDof = user.provider === 'dof';
  // const isProviderDof = false;

  // const [isInvalidPassword, setIsInvalidPassword] = useState(
  //   deletePatientError?.message === invalidFormType.invalidPassword,
  // );
  const isInvalidPassword = deletePatientFailure || deletePatientError;
  const [buttonValid, setButtonValid] = useState<boolean>(true);
  const [isDeletePatientSuccessOpen, setIsDeletePatientSuccessOpen] = useState<boolean>(false);

  const passwordRef = useRef<HTMLInputElement>(null);
  const handleDeletePatient = () => {
    // if (user.provider)
    const submitData = {
      password: encodedByAES56(password.value, user?.authority),
      provider: user.provider,
      // provider: 'google',
    };

    PatientActions.delete_patient_request({
      patientCode: patientInfo?.patientCode,
      data: submitData,
    });
  };

  const handleClickChangePassword = () => {
    // console.log('BASE_AUTH_URL', BASE_AUTH_URL);

    // AuthActions.connect_auth_password_request();
    // window.open('http://15.164.27.98:27015/password/inquiry', '_black');
    const urlPath = `${BASE_AUTH_URL}/password/inquiry`;

    if (!ipcRenderer) {
      window.open(urlPath);
    } else {
      ipcRenderer.send('openBrowser', {
        url: urlPath,
      });
    }
  };

  useEffect(() => {
    return () => {
      PatientActions.delete_patient_clear();
    };
  }, []);

  useEffect(() => {
    if (!isProviderDof) {
      setButtonValid(false);
    } else if (password.value.length > 0) {
      setButtonValid(false);
    } else {
      setButtonValid(true);
    }
  }, [password.value]);

  useDidUpdateEffect(() => {
    if (!deletePatientFailure) return;
    setButtonValid(true);
    passwordRef.current?.focus();
  }, [deletePatientFailure]);

  // const handleGoToBack = () => {
  //   history.push(pageUrl.patient.list);
  // };

  // useDidUpdateEffect(() => {
  //   setIsDeletePatientSuccessOpen(true);

  //   AppActions.add_popup({
  //     isOpen: isDeletePatientSuccessOpen,
  //     timeout: 0,
  //     isCloseIcon: true,
  //     title: '',
  //     okText: t(`GLOBAL_CONFIRM`),
  //     isCloseIconButton: false,
  //     content: (
  //       <AlertModalContent
  //         title={t(`PATIENT_DELETE_COMPLETE_TITLE`)}
  //         mainText={t(`PATIENT_DELETE_COMPLETE_CONTENTS`)}
  //         subText={''}
  //       />
  //     ),
  //     onClick: () => {
  //       setIsDeletePatientSuccessOpen(false);
  //       handleGoToBack();
  //     },
  //   });
  // }, [deletePatientSuccess]);

  return (
    <StyledDeletePatientModal data-component-name="PatientModal">
      <div
        className={cx('deletePatientModal__wrapper', {
          social: !isProviderDof,
        })}
      >
        <div className="deletePatientModal__container">
          <AlertModalContent
            title={t(`PATIENT_DELETE_INFO_TITLE`)}
            mainText={t(`PATIENT_DELETE_INFO_CONTENTS`, {
              patientName: !!patientInfo?.firstName
                ? patientInfo.firstName
                : '' + ' ' + !!patientInfo?.lastName
                ? patientInfo.lastName
                : '',
            })}
            subText={''}
          />
          {isProviderDof && (
            <>
              <div className="deletePatientModal__password__box">
                {/* <CustomText fontSize={16} fontWeight={500}>
              Password
            </CustomText> */}
                {/* <input
              className="password__input"
              style={{ width: 280, height: 40, borderRadius: 3, border: 'solid 1px #d1d1d1' }}
            /> */}
                <MuiWrapper>
                  <TextField
                    id="password"
                    name="password"
                    placeholder="password"
                    variant="outlined"
                    fullWidth
                    autoComplete="off"
                    inputProps={{
                      maxLength: 20,
                    }}
                    error={isInvalidPassword}
                    value={password.value}
                    onChange={password.onChange}
                    onKeyUp={e => e.key === 'Enter' && handleDeletePatient()}
                    type="password"
                    inputRef={passwordRef}
                  />
                </MuiWrapper>
                {isInvalidPassword && (
                  <div className="deletePatientModal__password__error form__error_text">
                    <div>*</div>
                    <CustomText>
                      <T>INVALID_PASSWORD</T>
                    </CustomText>
                  </div>
                )}
              </div>
              <button
                className="deletePatientModal__forgot_password"
                onClick={handleClickChangePassword}
              >
                <CustomText fontSize={14} fontColor="#888">
                  <span style={{ textDecoration: 'underline' }}>
                    <T>SIGNIN_FORGET_PASSWORD</T>
                  </span>
                </CustomText>
                <span>&nbsp;</span>
                <CustomText fontSize={14} fontColor="#444">
                  <span style={{ textDecoration: 'underline' }}>
                    <T>GLOBAL_RESET</T>
                  </span>
                </CustomText>
              </button>
            </>
          )}
        </div>
        <StyledPlainButtonOuter
          className="deletePatientModal__publish_btn_box detail"
          backgroundColor={color.navy_blue}
          left="50%"
          width={370}
          height={76}
        >
          {/* {isInvalidPassword && (
            <MuiButton
              config={{
                width: '100%',
              }}
              fullWidth
              disableElevation
              variant="contained"
              className="xl border-radius-round "
              onClick={handleClickChangePassword}
            >
              <span className="btn-shadow-inset"></span>
              <T>GLOBAL_FIND_PASSWORD</T>
            </MuiButton>
          )} */}
          <MuiButton
            config={{
              width: '320px',
            }}
            fullWidth
            // disabled={!firstName.value || !lastName.value || !birthday.value}
            disabled={buttonValid}
            disableElevation
            color="primary"
            variant="contained"
            disablebackground={color.navy_blue}
            disablefontcolor="#ffffff"
            className="xl border-radius-round"
            onClick={() => {
              handleDeletePatient();
            }}
          >
            <T>GLOBAL_DELETE</T>
          </MuiButton>
        </StyledPlainButtonOuter>
      </div>
    </StyledDeletePatientModal>
  );
}

const StyledDeletePatientModal = styled.section<{}>`
  .deletePatientModal__wrapper {
    position: relative;
    width: 100%;
    margin-bottom: 30px;
    background-color: #ffffff;
    border-radius: 15px;
    height: 380px;
    padding-top: 10px;
    padding: 30px 30px 50px 30px;
    &.social {
      height: 250px;
    }
    .deletePatientModal__container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .deletePatientModal__password__box {
        display: block;
        flex-direction: column;
        width: 280px;
        justify-content: flex-start;
        /* grid-template-columns: 2fr 8fr;
        grid-template-rows: auto auto;
        grid-column-gap: 20px; */
        align-items: center;
      }
      .deletePatientModal__password__error {
        display: flex;
        column-gap: 5px;
      }
      .deletePatientModal__forgot_password {
        display: flex;
        position: absolute;
        bottom: 70px;
      }
    }
    .deletePatientModal__publish_btn_box {
      display: flex;
      /* position: relative; */
      column-gap: 10px;
    }
  }
`;

export default React.memo(DeletePatientModalContainer);
